<div class="search">
  <mat-form-field>
    <mat-label>{{ 'SEARCH.PLACEHOLDER' | translate }}</mat-label>
    <spx-icon-button [disabled]="!searchControl.valid || !searchControl.value" (click)="search()" matPrefix [iconName]="'search'" [type]="'mat-icon-button'"></spx-icon-button>
    <input matInput [formControl]="searchControl" (keyup)="search($event)" />
    <spx-icon matTooltip="{{ 'SEARCH.TOOLTIP' | translate }} {{ 'SEARCH.HINT' | translate }}" matSuffix [name]="'info'"></spx-icon>
  </mat-form-field>
</div>
